<ng-template #railairtemp let-r="result" let-t="term">
  <div class="light-flex">
    @if (!r.group) {
      <i class="ico-flight item-icon" aria-hidden="true"></i>
    }
    @if (r.group) {
      <span class="multiairportgrouping">
        <i class="ico-flight" aria-hidden="true"></i>
      </span>
    }
    <span class="item-code">{{ r.code }}</span>
    <span class="item-dest">{{ r.destination | flightFormat }} ({{ r.gateway }})</span>
  </div>
</ng-template>

<ng-template #airlinesTemplate let-r="result" let-t="term">
  {{ r.name }}
</ng-template>

@if (
  {
    criteria: (searchParams.timeCriteriaOptions | async) || [],
    flightOperators: (searchParams.flightOperators | async) || [],
    avaliableClasses: (searchParams.avaliableClasses | async) || []
  };
  as data
) {
  <div id="flightSearchForm">
    <p>
      <app-light-toggle-group [class.has-multi-city]="showMultiCity">
        <app-light-toggle-btn
          [selected]="searchParams.chosenSearchType === FlightSearchType.oneWay"
          (click)="
            searchParams.chosenSearchType = FlightSearchType.oneWay;
            searchService.isFavoritesSelected = false
          "
          iconClass="ico-oneway"
          id="flight-tab-one-way"
          i18n="@@eurostarSearchOneWayOnly"
          >One way</app-light-toggle-btn
        >
        <app-light-toggle-btn
          [selected]="searchParams.chosenSearchType === FlightSearchType.return"
          (click)="
            searchParams.chosenSearchType = FlightSearchType.return;
            searchService.isFavoritesSelected = false
          "
          iconClass="ico-return"
          id="flight-tab-return"
          i18n="@@irlSearchTravellingReturn"
          >Return</app-light-toggle-btn
        >
        @if (showMultiCity) {
          <app-light-toggle-btn
            [selected]="searchParams.chosenSearchType === FlightSearchType.multiCity"
            (click)="setUpMultiCitySearch()"
            iconClass="ico-return"
            id="flght-tab-multi-city"
            i18n="@@flightSearchMultiCity"
            >Multi-city</app-light-toggle-btn
          >
        }
      </app-light-toggle-group>
    </p>
    @if (!searchService.isFavoritesSelected) {
      @if (searchParams?.clonedBasketItemDetails.outboundFlights) {
        <div>
          <app-cloned-details
            [flights]="searchParams?.clonedBasketItemDetails.outboundFlights"
          ></app-cloned-details>
        </div>
      }
      @if (searchParams.chosenSearchType !== FlightSearchType.multiCity) {
        <div>
          <fieldset>
            <legend class="visuallyhidden">Outbound Flight</legend>
            <div class="inputs-container">
              <div class="five-eighths-container flex-row-container--end">
                <div class="five-eighth">
                  <div class="flex-row-container flight-input-mobile flex-row-container--end">
                    <div class="flex-column-container combo-box-left">
                      <label
                        id="outboundFlightDep"
                        class="header-label split-label"
                        i18n="@@flightSearchOutboundDep"
                        >From</label
                      >
                      <i class="ico-icon-takeoff combo-box-icon" aria-hidden="true"></i>
                      <input
                        autocomplete="off"
                        name="flight1"
                        i18n-placeholder
                        placeholder="Enter an airport"
                        type="text"
                        id="flight-input-outbound-flight-depart"
                        appInput
                        [ngModel]="searchParams.departLocation"
                        (selectItem)="updateLocation($event.item)"
                        [ngbTypeahead]="flightLocations"
                        [resultTemplate]="railairtemp"
                        [inputFormatter]="formatter_rail_air"
                        (click)="$event.currentTarget.select()"
                        (focus)="focus$.next($event.target.value)"
                        aria-labelledby="outboundFlightDep"
                        (keyup.arrowdown)="ensureElementIsScrolledTo($event)"
                        (keyup.arrowup)="ensureElementIsScrolledTo($event)"
                        [hasError]="
                          searchParams.validationMessages?.includes(
                            'Please add in a departure location'
                          )
                        "
                      />
                      @if (departLocationIsLoading | async) {
                        <i class="button_spinner input-loading-spinner-right"></i>
                      }
                    </div>
                    <app-swap-button
                      class="flight"
                      [departLocation]="searchParams.departLocation"
                      [arriveLocation]="searchParams.arriveLocation"
                      (locationsSwapped)="handleLocationsSwapped($event)"
                    >
                    </app-swap-button>
                    <div class="flex-column-container combo-box-right">
                      <label
                        id="outboundFlightArr"
                        class="header-label split-label"
                        i18n="@@flightSearchOutboundArr"
                        >To</label
                      >
                      <i class="ico-icon-landing combo-box-icon" aria-hidden="true"></i>
                      <input
                        #ofa
                        autocomplete="off"
                        name="flight1"
                        i18n-placeholder
                        id="flight-input-outbound-flight-arrive"
                        placeholder="Enter an airport"
                        type="text"
                        appInput
                        [ngModel]="searchParams.arriveLocation"
                        (selectItem)="updateLocation($event.item, true)"
                        [ngbTypeahead]="flightLocations2"
                        [resultTemplate]="railairtemp"
                        [inputFormatter]="formatter_rail_air"
                        (click)="$event.currentTarget.select()"
                        (focus)="focus2$.next($event.target.value)"
                        aria-labelledby="outboundFlightArr"
                        (keyup.arrowdown)="ensureElementIsScrolledTo($event)"
                        (keyup.arrowup)="ensureElementIsScrolledTo($event)"
                        [hasError]="
                          searchParams.validationMessages?.includes(
                            'Please add in an arrival destination'
                          )
                        "
                      />
                      @if (arriveLocationIsLoading | async) {
                        <i class="button_spinner input-loading-spinner-right"></i>
                      }
                    </div>
                  </div>
                </div>
                <div class="three-eighth">
                  <div
                    class="flex-row-container"
                    [ngClass]="{
                      'error-box':
                        !searchService.isFavouriteSearch &&
                        searchParams.validationMessages?.includes(
                          'Departure date can not be in the past'
                        )
                    }"
                  >
                    <ngbd-datepicker-i18n>
                      <div class="flex-column-container two-third">
                        <label
                          class="header-label date-label"
                          i18n="@@ferrySearchOutboundDate"
                          for="outbound_flight_date"
                          >Outbound date (DD/MM/YYYY)</label
                        >
                        <i
                          class="ico-calendar combo-box-icon cursor_pointer"
                          aria-hidden="true"
                        ></i>
                        <app-datepicker
                          [minDate]="searchParams.minimumOutBoundDate"
                          [startDate]="searchParams.departDate"
                          [model]="searchParams.departDate"
                          [from]="
                            searchParams.chosenSearchType === FlightSearchType.return
                              ? searchParams.departDate
                              : null
                          "
                          [to]="
                            searchParams.chosenSearchType === FlightSearchType.return
                              ? searchParams.returnDate
                              : null
                          "
                          (newFrom)="searchParams.departDate = $event; checkHotelCheckbox()"
                          (newTo)="searchParams.returnDate = $event; checkHotelCheckbox()"
                          (newDate)="searchParams.departDate = $event; checkHotelCheckbox()"
                          [class]="'combo-box'"
                          [componentId]="'outbound_flight_date'"
                        >
                        </app-datepicker>
                      </div>
                      <div class="flex-column-container one-third">
                        <label
                          class="header-label"
                          i18n="@@AriaRailOutboundTime"
                          for="outbound_flight_time"
                          >Outbound time</label
                        >
                        <i class="ico-clock select-box-icon"></i>
                        <select
                          #oft
                          id="outbound_flight_time"
                          appSelect
                          [ngClass]="{
                            time_disabled: searchParams.outTimeCriteria === TimeWindow.Anytime
                          }"
                          [hasError]="
                            !searchService.isFavouriteSearch &&
                            searchParams.validationMessages?.includes(
                              'The time of arrival cannot be less than the time of departure'
                            )
                          "
                          [(ngModel)]="searchParams.departTime"
                          [disabled]="searchParams.outTimeCriteria === TimeWindow.Anytime"
                          aria-labelledby="aria-flight-outbound-time_1"
                          tabindex="0"
                        >
                          @for (time of searchParams.timeArray; track time) {
                            <option [ngValue]="time.value">
                              {{ time.display }}
                            </option>
                          }
                        </select>
                      </div>
                      @if (searchParams.outTimeCriteria === TimeWindow.Depart) {
                        <div class="time-flexibility-container">
                          <span
                            id="aria-out-time-flexibility"
                            hidden
                            i18n="@@AriaOutboundTimeControlFlight"
                            >Ability to increase / decrease outbound Flight time window in
                            hours</span
                          >
                          <div class="flex-column-container">
                            <label
                              class="header-label"
                              i18n="@@flightSearchFlex"
                              for="outbound_flight_flexibility"
                              >Flexibility</label
                            >
                            <app-plus-minus-icon></app-plus-minus-icon>
                            <select
                              [ngClass]="{
                                time_disabled: searchParams.outTimeCriteria === TimeWindow.Anytime
                              }"
                              [disabled]="searchParams.outTimeCriteria === TimeWindow.Anytime"
                              name="out-time-flexibility"
                              i18n-placeholder
                              aria-describedby="aria-out-time-flexibility"
                              appSelect
                              [(ngModel)]="searchParams.outTimeFlexibility"
                              id="outbound_flight_flexibility"
                            >
                              @for (hour of flexibilityHours; track hour) {
                                <option [ngValue]="hour">
                                  {{ hour }}
                                </option>
                              }
                            </select>
                          </div>
                        </div>
                      }
                    </ngbd-datepicker-i18n>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="flex-row-container flex-row-container--right flex-row-container--tb-margin flex-row-container--reset"
            >
              <mat-radio-group
                [(ngModel)]="searchParams.outTimeCriteria"
                aria-label="outbound flight time preferences"
                id="flight-outbound-flight-time-pref"
                i18n-aria-label="@@AriaOutboundFlightTimePreferences"
                class="triple-radio-buttons"
              >
                @for (flightcrit of data.criteria; track flightcrit) {
                  <mat-radio-button
                    class="light-primary"
                    color="primary"
                    [value]="flightcrit"
                    id="flight-radio-crit-{{ flightcrit ? (flightcrit | removeSpaces) : '' }}"
                  >
                    <span>{{ flightcrit | translate }}</span>
                  </mat-radio-button>
                }
              </mat-radio-group>
            </div>
          </fieldset>
        </div>
      }
      <!-- Multi-city search -->
      @if (searchParams.chosenSearchType === FlightSearchType.multiCity) {
        <div>
          <app-multi-city-search
            [flightDestinationArray]="multiCitySearch"
            [flightLocations]="flightLocations"
            [flightLocations2]="flightLocations2"
            [formatter_rail_air]="formatter_rail_air"
            [minDate]="searchParams.minDate"
            [minNextDate]="minimumMultiCityDate"
            [outTimeCriteria]="searchParams.outTimeCriteria"
            [criteria]="data.criteria"
            [maxSectors]="maxSectors"
            (selectedInput)="updateMultiCityDateTime($event)"
          ></app-multi-city-search>
        </div>
      }
      <fieldset>
        @if (searchParams?.clonedBasketItemDetails.inboundFlights) {
          <div>
            <app-cloned-details
              [flights]="searchParams?.clonedBasketItemDetails.inboundFlights"
            ></app-cloned-details>
          </div>
        }
        <legend class="visuallyhidden">Return Flight</legend>
        @if (searchParams.chosenSearchType === FlightSearchType.return) {
          <div class="five-eighths-container flex-row-container--end">
            <div class="five-eighth">
              <div class="flex-row-container flight-input-mobile flex-row-container--end">
                <div class="flex-column-container combo-box-left">
                  <label
                    class="header-label split-label"
                    id="returnFlightDep"
                    i18n="@@flightSearchReturnFlightDep"
                    >From</label
                  >
                  <i class="ico-icon-landing combo-box-icon" aria-hidden="true"></i>
                  <input
                    #ofa
                    autocomplete="off"
                    name="flight2"
                    i18n-placeholder
                    placeholder="Enter an airport"
                    id="flight-input-return-flight-depart"
                    type="text"
                    appInput
                    [(ngModel)]="searchParams.arriveLocation"
                    [ngbTypeahead]="flightLocations3"
                    [resultTemplate]="railairtemp"
                    [inputFormatter]="formatter_rail_air"
                    (click)="$event.currentTarget.select()"
                    (focus)="focus3$.next($event.target.value)"
                    aria-labelledby="returnFlightDep"
                    (keyup.arrowdown)="ensureElementIsScrolledTo($event)"
                    (keyup.arrowup)="ensureElementIsScrolledTo($event)"
                  />
                  @if (arriveLocationIsLoading | async) {
                    <i class="button_spinner input-loading-spinner-right"></i>
                  }
                </div>
                <app-swap-button
                  class="flight"
                  [departLocation]="searchParams.departLocation"
                  [arriveLocation]="searchParams.arriveLocation"
                  (locationsSwapped)="handleLocationsSwapped($event)"
                >
                </app-swap-button>
                <div class="flex-column-container combo-box-right">
                  <label
                    class="header-label split-label"
                    id="returnFlightArr"
                    i18n="@@flightSearchReturnFlightArr"
                    >To</label
                  >
                  <i class="ico-icon-takeoff combo-box-icon" aria-hidden="true"></i>
                  <input
                    autocomplete="off"
                    name="flight3"
                    i18n-placeholder
                    placeholder="Enter an airport"
                    type="text"
                    id="flight-input-return-flight-arrive"
                    appInput
                    [(ngModel)]="searchParams.departLocation"
                    (selectItem)="checkHotelCheckbox()"
                    [ngbTypeahead]="flightLocations4"
                    [resultTemplate]="railairtemp"
                    [inputFormatter]="formatter_rail_air"
                    (click)="$event.currentTarget.select()"
                    (focus)="focus4$.next($event.target.value)"
                    aria-labelledby="returnFlightArr"
                    (keyup.arrowdown)="ensureElementIsScrolledTo($event)"
                    (keyup.arrowup)="ensureElementIsScrolledTo($event)"
                  />
                  @if (departLocationIsLoading | async) {
                    <i class="button_spinner input-loading-spinner-right"></i>
                  }
                </div>
              </div>
            </div>
            <div class="three-eighth">
              <div class="flex-row-container">
                <ngbd-datepicker-i18n>
                  <div class="flex-column-container two-third">
                    <label
                      class="header-label date-label"
                      i18n="@@ferrySearchReturnDate"
                      for="return_flight_date"
                      >Return date (DD/MM/YYYY)</label
                    >
                    <i class="ico-calendar combo-box-icon cursor_pointer" aria-hidden="true"></i>
                    <app-datepicker
                      [minDate]="searchParams.minimumOutBoundDate"
                      [startDate]="searchParams.returnDate || searchParams.departDate"
                      [model]="searchParams.returnDate"
                      [from]="searchParams.departDate"
                      [to]="searchParams.returnDate"
                      (newFrom)="searchParams.departDate = $event; checkHotelCheckbox()"
                      (newTo)="searchParams.returnDate = $event; checkHotelCheckbox()"
                      [class]="'combo-box'"
                      [componentId]="'return_flight_date'"
                      (newDate)="searchParams.returnDate = $event; checkHotelCheckbox()"
                    >
                    </app-datepicker>
                  </div>
                  <div class="flex-column-container one-third">
                    <label
                      class="header-label"
                      i18n="@@AriaFerryReturnDate"
                      for="return_flight_time"
                      >Return time</label
                    >
                    <i class="ico-clock select-box-icon select-box-icon"></i>
                    <select
                      appSelect
                      id="return_flight_time"
                      [(ngModel)]="searchParams.arriveTime"
                      [disabled]="searchParams.inTimeCriteria === TimeWindow.Anytime"
                      [ngClass]="{
                        time_disabled: searchParams.inTimeCriteria === TimeWindow.Anytime
                      }"
                      [hasError]="
                        !searchService.isFavouriteSearch &&
                        searchParams.validationMessages?.includes(
                          'The time of arrival cannot be less than the time of departure'
                        )
                      "
                      aria-describedby="returnFlight"
                      tabindex="0"
                      aria-labelledby="aria-flight-outbound-time_2"
                    >
                      @for (time of searchParams.timeArray; track time) {
                        <option [ngValue]="time.value">
                          {{ time.display }}
                        </option>
                      }
                    </select>
                  </div>
                  @if (searchParams.inTimeCriteria == TimeWindow.Depart) {
                    <div class="time-flexibility-container">
                      <span id="aria-in-time-flexibility" hidden i18n="@@AriaInboundTimeControl"
                        >Ability to increase / decrease inbound flight time window in hours</span
                      >
                      <div class="flex-column-container">
                        <label
                          class="header-label"
                          i18n="@@flightSearchFlex"
                          for="return_flight_flexibility"
                          >Flexibility</label
                        >
                        <app-plus-minus-icon></app-plus-minus-icon>
                        <select
                          [ngClass]="{
                            time_disabled: searchParams.inTimeCriteria === TimeWindow.Anytime
                          }"
                          [disabled]="searchParams.inTimeCriteria === TimeWindow.Anytime"
                          name="in-time-flexibility"
                          i18n-placeholder
                          aria-describedby="aria-in-time-flexibility"
                          appSelect
                          [(ngModel)]="searchParams.inTimeFlexibility"
                          id="return_flight_flexibility"
                        >
                          @for (hour of flexibilityHours; track hour) {
                            <option [ngValue]="hour">
                              {{ hour }}
                            </option>
                          }
                        </select>
                      </div>
                    </div>
                  }
                </ngbd-datepicker-i18n>
              </div>
            </div>
          </div>
        }
        @if (searchParams.chosenSearchType === FlightSearchType.return) {
          <div
            class="flex-row-container flex-row-container--right flex-row-container--tb-margin flex-row-container--reset"
          >
            <mat-radio-group
              [(ngModel)]="searchParams.inTimeCriteria"
              aria-label="return flight time preferences"
              id="flight-return-flight-time-pref"
              class="triple-radio-buttons timecrit-buttons"
            >
              @for (flightcrit of data.criteria; track flightcrit) {
                <mat-radio-button
                  class="light-primary"
                  color="primary"
                  [value]="flightcrit"
                  id="flight-radio-return-crit-{{ flightcrit ? (flightcrit | removeSpaces) : '' }}"
                >
                  <span>{{ flightcrit | translate }}</span>
                </mat-radio-button>
              }
            </mat-radio-group>
          </div>
        }
      </fieldset>
      <!-- ! START OF CHECKBOXES-->
      <fieldset>
        <legend>
          <h2 i18n="@@flightSearchOptions" class="rem-1-5">Options</h2>
        </legend>
        <div class="flex-row-container flex-column-mobile">
          <div class="option_checkbox">
            <div>
              <mat-checkbox
                class="light-primary flight-search-checkbox"
                color="primary"
                i18n="@@flightSearchDirectOnly"
                [checked]="searchParams.maxConnections === 0"
                #checked
                id="flight-checkbox-direct-only"
                (change)="direct(checked.checked)"
                (keydown.enter)="direct(checked)"
              >
                Direct only
              </mat-checkbox>
            </div>
          </div>
          @if (searchParams.chosenSearchType !== FlightSearchType.multiCity) {
            <div class="option_checkbox">
              <div>
                <mat-checkbox
                  class="light-primary flight-search-checkbox"
                  color="primary"
                  i18n="@@flightSearchForAirports"
                  id="flight-checkbox-nearby-airports"
                  [(ngModel)]="searchParams.includeNearbyAirports"
                  (keydown.enter)="
                    searchParams.includeNearbyAirports = !searchParams.includeNearbyAirports
                  "
                >
                  Search for nearby airports
                </mat-checkbox>
              </div>
            </div>
          }
          @if (showVia) {
            <div class="option_checkbox">
              <div>
                <mat-checkbox
                  class="light-primary flight-search-checkbox"
                  color="primary"
                  [(ngModel)]="searchParams.showVia"
                  id="flight-checkbox-via"
                  i18n="@@flightSearchVia"
                  (change)="viaChanged()"
                  >Via</mat-checkbox
                >
              </div>
            </div>
          }
        </div>
        @if (searchParams.showVia) {
          <div>
            <div class="two-third">
              <label class="header-label" id="aria-flight-via-destination" i18n="@@flightSearchVia"
                >Via</label
              >
              <div class="flex-row-container flight-input-mobile">
                <i class="ico-icon-takeoff combo-box-icon" aria-hidden="true"></i>
                <input
                  autocomplete="off"
                  name="flight1"
                  i18n-placeholder
                  placeholder="Enter an airport"
                  type="text"
                  appInput
                  class="combo-box-left"
                  [(ngModel)]="searchParams.via"
                  [ngbTypeahead]="flightLocationsVia"
                  [resultTemplate]="railairtemp"
                  [inputFormatter]="formatter_rail_air"
                  (click)="$event.currentTarget.select()"
                  (focus)="focusVia$.next($event.target.value)"
                  aria-labelledby="aria-flight-via-destination"
                  id="flight-input-via"
                  (keyup.arrowdown)="ensureElementIsScrolledTo($event)"
                  (keyup.arrowup)="ensureElementIsScrolledTo($event)"
                />
                @if (viaLocationIsLoading | async) {
                  <i class="button_spinner input-loading-spinner-right"></i>
                }
              </div>
            </div>
          </div>
        }
      </fieldset>
      <!-- ! END OF CHECKBOXES -->
      @if (searchParams.showPreferredAirlines) {
        <fieldset>
          <legend>
            <label class="header-label" id="preferredAirline" i18n="@@flightSearchChoosePreferred"
              >Choose airlines</label
            >
          </legend>
          <div class="quarter-container">
            <div class="quarter-block">
              <input
                autocomplete="off"
                name="flight_airlines"
                i18n-placeholder
                placeholder="Any"
                type="text"
                appInput
                [(ngModel)]="searchParams.operator1"
                [ngbTypeahead]="firstAirline"
                [resultTemplate]="airlinesTemplate"
                [inputFormatter]="formatter_airlines"
                (click)="$event.currentTarget.select()"
                (focus)="focus5$.next($event.target.value)"
                aria-labelledby="preferredAirline1"
                id="flight-input-airline-1"
                (keyup.arrowdown)="ensureElementIsScrolledTo($event)"
                (keyup.arrowup)="ensureElementIsScrolledTo($event)"
              />
              <span id="preferredAirline1" hidden i18n="@@flightSearchFirstPreferredAirline"
                >First airline</span
              >
            </div>
            <div class="quarter-block">
              <input
                autocomplete="off"
                name="secondAirline"
                i18n-placeholder
                placeholder="Any"
                type="text"
                appInput
                [(ngModel)]="searchParams.operator2"
                [ngbTypeahead]="secondAirline"
                [resultTemplate]="airlinesTemplate"
                [inputFormatter]="formatter_airlines"
                (click)="$event.currentTarget.select()"
                (focus)="focus6$.next($event.target.value)"
                aria-labelledby="preferredAirline2"
                id="flight-input-airline-2"
                (keyup.arrowdown)="ensureElementIsScrolledTo($event)"
                (keyup.arrowup)="ensureElementIsScrolledTo($event)"
              />
              <span id="preferredAirline2" hidden i18n="@@flightSearchSecondPreferredAirline"
                >Second airline</span
              >
            </div>
            <div class="quarter-block">
              <input
                autocomplete="off"
                name="thirdAirline"
                i18n-placeholder
                placeholder="Any"
                type="text"
                appInput
                [(ngModel)]="searchParams.operator3"
                [ngbTypeahead]="thirdAirline"
                [resultTemplate]="airlinesTemplate"
                [inputFormatter]="formatter_airlines"
                (click)="$event.currentTarget.select()"
                (focus)="focus7$.next($event.target.value)"
                aria-labelledby="preferredAirline3"
                id="flight-input-airline-3"
                (keyup.arrowdown)="ensureElementIsScrolledTo($event)"
                (keyup.arrowup)="ensureElementIsScrolledTo($event)"
              />
              <span id="preferredAirline3" hidden i18n="@@flightSearchThirdPreferredAirline"
                >Third airline</span
              >
            </div>
            <div class="quarter-block">
              <input
                autocomplete="off"
                name="fourthAirline"
                i18n-placeholder
                placeholder="Any"
                type="text"
                appInput
                [(ngModel)]="searchParams.operator4"
                [ngbTypeahead]="fourthAirline"
                [resultTemplate]="airlinesTemplate"
                [inputFormatter]="formatter_airlines"
                (click)="$event.currentTarget.select()"
                (focus)="focus8$.next($event.target.value)"
                aria-labelledby="preferredAirline4"
                id="flight-input-airline-4"
                (keyup.arrowdown)="ensureElementIsScrolledTo($event)"
                (keyup.arrowup)="ensureElementIsScrolledTo($event)"
              />
              <span id="preferredAirline4" hidden i18n="@@flightSearchFourthPreferredAirline"
                >Fourth airline</span
              >
            </div>
          </div>
        </fieldset>
      }
      @if (searchParams.showCabinClassSelection) {
        <div class="half-container">
          <div class="half-block">
            <label
              class="header-label"
              id="PreferredClassO"
              i18n="@@flightSearchChoosePreferredOut"
              for="flight-input-class"
              >Outbound class</label
            >
            <select
              [(ngModel)]="searchParams.cabinClass"
              appSelect
              [noIcon]="true"
              aria-labelledby="PreferredClassO"
              id="flight-input-class"
            >
              @for (class of data.avaliableClasses; track class) {
                <option [value]="class.type">
                  {{ class.name | translate }}
                </option>
              }
            </select>
          </div>
          <div class="half-block">
            @if (searchParams.chosenSearchType === FlightSearchType.return) {
              <div>
                <label
                  class="header-label"
                  id="PreferredClassI"
                  i18n="@@flightSearchChoosePreferredIn"
                  for="flight-input-return-class"
                  >Return class</label
                >
                <select
                  [(ngModel)]="searchParams.returnCabinClass"
                  appSelect
                  [noIcon]="true"
                  aria-labelledby="PreferredClassI"
                  id="flight-input-return-class"
                >
                  @for (class of data.avaliableClasses; track class) {
                    <option [value]="class.type">
                      {{ class.name | translate }}
                    </option>
                  }
                </select>
              </div>
            }
          </div>
        </div>
      }
      @if (
        searchParams.chosenSearchType === FlightSearchType.return &&
        displayHotelCheck &&
        toggleHotelSearchRequested.observed &&
        services[ServiceType.Hotel] &&
        !searchParams.isFlightHotelComboSearch
      ) {
        <div class="flex-row-container hotel-check">
          <button
            appButton="large"
            color="primary"
            [attr.aria-pressed]="hotelsearchRequested"
            id="flight-checkbox-hotel-{{ hotelsearchRequested ? 'remove' : 'add' }}"
            (click)="toggleHotelCheckbox()"
          >
            @if (!hotelsearchRequested) {
              <span i18n="@@eurostarAddHotelcheck"> Add Hotel </span>
            }
            @if (hotelsearchRequested) {
              <span i18n="@@eurostarRemoveHotelcheck"> Remove Hotel </span>
            }
          </button>
        </div>
      }
    } @else {
      <app-favorite-items [serviceType]="ServiceType.Flight"> </app-favorite-items>
    }
  </div>
  @if (
    searchParams.isFlightHotelComboSearch ||
    (hotelsearchRequested &&
      toggleHotelSearchRequested.observed &&
      searchParams.chosenSearchType === FlightSearchType.return)
  ) {
    <h2 class="hotel-header">Hotel</h2>
    <app-hotel-search [town]="hotelTown"></app-hotel-search>
  }
}
<app-flight-loading-screen></app-flight-loading-screen>
